import styled from "styled-components";
import { Link } from "react-router-dom";
import { device } from "../Layout/mediaQuery";

export const Navbar = styled.div`
  width: 4.5%;
  height: 100vh;
  min-height: 500px;
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 1px 1px 3px rgb(0 0 0 / 20%);
  @media ${device.desktops} {
    width: 6%;
  }
  @media ${device.landscapeMobile} {
    width: 100%;
    flex-direction: row;
    height: 12vh;
    min-height: unset;
    align-items: baseline;
  }
`;

export const Logo = styled(Link)`
  display: block;
  padding: 15px 0;
  text-align: center;
  @media ${device.landscapeMobile} {
    display: none;
  }
`;
export const LogoImg = styled.img`
  display: block;
  margin: 0px auto;
  width: 85%;
  height: auto;
`;

export const Nav = styled.div`
  width: 100%;
  text-align: center;
  a {
    font-size: 22px;
    display: block;
    line-height: 51px;
    height: 51px;
    position: relative;
    text-decoration: none;

    svg {
      color: ${(props) => props.theme.colorsPalette.primaryColor};
      opacity: 0.3;
    }
    i {
      transition: all 0.3s ease-out;
    }
    &:hover {
      color: ${(props) => props.theme.colorsPalette.primaryColor};
      svg {
        opacity: 0;
      }
      &:after {
        opacity: 1;
      }
    }
    &:after {
      content: "";
      font-size: 0.3em;

      letter-spacing: 1.2px;
      position: absolute;
      bottom: 0;
      display: block;
      width: 100%;
      text-align: center;
      opacity: 0;
      transition: all 0.3s ease-out;
    }
    &:first-child {
      &::after {
        content: "<HOME/>";
      }
    }
    &.about-link {
      &::after {
        content: "<ABOUT/>";
      }
    }

    &.contact-link {
      &::after {
        content: "<CONTACT/>";
      }
    }
    &.projects-link {
      &::after {
        content: "<PROJECTS/>";
      }
    }

    &.active {
      svg {
        opacity: 1;
        color: ${(props) => props.theme.colorsPalette.primaryColor};
      }
    }
    &.active:hover {
      svg {
        opacity: 0;
      }
    }
    @media ${device.landscapeMobile} {
      font-size: 18px;
      margin: 0 6%;
      &:first-child {
        margin-left: 0;
        &:after {
          right: 45%;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      &:after {
        font-size: 7px;
        bottom: -20px;
        right: 85%;
        opacity: 0.3;
        color: ${(props) => props.theme.colorsPalette.primaryColor};
      }

      &.active {
        opacity: 1;
        svg {
          opacity: 1;
        }
        &:after {
          opacity: 1;
        }
      }
      &.active:hover {
        svg {
          opacity: 1;
        }
      }
    }
  }
  @media ${device.landscapeMobile} {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;

export const List = styled.ul`
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  margin-bottom: 10px;
  @media ${device.landscapeMobile} {
    display: none;
  }
`;
export const ListItem = styled.li`
  a {
    padding: 7px 0;
    display: block;
    font-size: 15px;
    line-height: 16px;
    color: ${(props) => props.theme.colorsPalette.primaryColor};
    svg {
      color: rgb(168, 178, 209);
    }
    &:hover svg {
      color: ${(props) => props.theme.colorsPalette.primaryColor};
    }
  }
`;
